import { useInfiniteQuery } from '@tanstack/react-query';
import { getReplaysByCategory } from '../../../lib/ApiService';
import { CategorizedReplays, PodcastOrReplay } from '../../../types';
import { isNativeAd } from '../../../lib/utils';

function isCategorizedReplays(data: any): data is CategorizedReplays {
    return 'replays' in data;
}

export default function useReplayByCategory(category: string, pageName?: string, isEldo4RealSwiper?: boolean, queryKey?: string) {
    const { data, status, error, fetchNextPage, hasNextPage, refetch, isFetchingNextPage } = useInfiniteQuery<PodcastOrReplay[] | CategorizedReplays>({
        queryKey: queryKey ? [queryKey] : [`podcastByCategory-${category}`],
        queryFn: ({ pageParam = 1 }) => getReplaysByCategory(category, pageName, pageParam.toString(), isEldo4RealSwiper),
        getNextPageParam: (item, allPages) => {
            if (isCategorizedReplays(item)) {
                return item.pagination.page === (Number(item.pagination.last_page)) ? undefined : allPages.length + 1;
            }
            return item.length === 0 ? undefined : allPages.length + 1;
        },
    });

    const loadMore = () => {
        if (hasNextPage) {
            fetchNextPage();
        }
    };

    const podcastByCategory = data?.pages.reduce<PodcastOrReplay[]>((acc, page) => {
        const items = isCategorizedReplays(page) ? page.replays : page;
        return [...acc, ...items.filter((item): item is PodcastOrReplay => !isNativeAd(item))];
    }, []) || [];

    return {
        podcastByCategory,
        isLoading: status === 'loading',
        error,
        loadMore,
        canLoadMore: hasNextPage,
        refetch,
        isFetchingNextPage,
    };
}


